export default "__VITE_ASSET__DQf3KdAy__"